import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { tokens } from "../theme";

export default function SectionLabel({
  children,
  index,
  align = "left",
}: {
  children: React.ReactNode;
  index?: string;
  align?: "left" | "center";
}) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        justifyContent: align === "center" ? "center" : "flex-start",
      }}
    >
      <Box sx={{ width: 28, height: "1px", bgcolor: tokens.brass }} />
      {index && (
        <Typography component="span" sx={{ fontFamily: tokens.sans, fontSize: "0.72rem", fontWeight: 700, letterSpacing: "0.18em", color: tokens.brass }}>
          {index}
        </Typography>
      )}
      <Typography variant="overline" component="span">
        {children}
      </Typography>
    </Box>
  );
}
